// This is a modal for Adminindustrysectorsone

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateIndustrysectorparentItems } from "./redux/slices/IndustrysectorcategoriesThunks";
import { updateIndustrysectorchildItem } from "./redux/slices/IndustrysectorchildThunks";

export default function ModalAdminindustryedit({
  onClose,
  industryParent,
  active,
}) {
  console.log(active);

  const dispatch = useDispatch();
  const [parentSelected, setParentSelected] = useState(active?.parent_id);
  const [sectorName, setSectorName] = useState(active?.industry_sector);

  const handler = async () => {
    if (active?.type == "Child") {
      const data = {
        _id: active._id,
        sector_name: sectorName,
        industry_sector_parent_id: parentSelected,
      };
      await dispatch(updateIndustrysectorchildItem(data));
    } else {
      const data = {
        _id: active._id,
        sector_name: sectorName,
      };
      await dispatch(updateIndustrysectorparentItems(data));
    }
    onClose();
  };

  return (
    <RootWrapperModalAdminindustrysectorsone>
      <Wrapper>
        <Sector>
          <Left>
            <Frame58>
              <Frame1391>
                <AddIndustrySector>Edit Industry Sector</AddIndustrySector>
              </Frame1391>
              <Frame1391>
                <PRTNR.Input
                  label="Industry Sector"
                  value={sectorName}
                  onChange={(e) => {
                    setSectorName(e.target.value);
                  }}
                />

                <PRTNR.Select
                  label="Select Type"
                  options={[]}
                  placeholder={active?.type == "Parent" ? "Parent" : "Child"}
                />

                {active?.type == "Child" && (
                  <PRTNR.Select
                    label="Parent Sector"
                    options={industryParent}
                    value={parentSelected}
                    onChange={(e) => {
                      setParentSelected(e.target.value);
                    }}
                    placeholder={industryParent}
                  />
                )}
              </Frame1391>
              <Frame1416>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    setParentSelected("");
                    setSectorName("");
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    borderRadius: "999px",
                    background: "rgb(241, 245, 249)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "rgb(33, 37, 67)",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Clear
                  </span>
                </AIMEButton>

                <AIMEButton
                  size="small"
                  onClick={() => {
                    handler();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "240px",
                    background: "rgb(97, 98, 197)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Save
                  </span>
                </AIMEButton>
              </Frame1416>
            </Frame58>
          </Left>
        </Sector>
      </Wrapper>
    </RootWrapperModalAdminindustrysectorsone>
  );
}

const RootWrapperModalAdminindustrysectorsone = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  width: 534px;
  padding: 24px;
`;

const Sector = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 486px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 486px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const AddIndustrySector = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1416 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
